import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import InputPlusAndMinus from "../../shared-components/InputPlusAndMinus";
import PackageDescription from "./package-item-components/PackageDescription";
import PackageTitle from "./package-item-components/PackageTitle";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

const PackageItem = (props) => {

  const [descriptionVisible, setDescriptionVisible] = useState(false)

  const toggleDescription = () => {
    !descriptionVisible
      ? setDescriptionVisible(true)
      : setDescriptionVisible(false);
  };

    const {
      selectable,
      inBasket,
      updatePackage,
      packageID,
      description,
      name,
      productNameList,
      packageBrand,
      price,
      canOrderMultiple,
      packageQuantity,
      packageClass,
      site,
      familyID
    } = props;

    /**
     * Change the classes if the item is not selectable or not in the basket or both.
     * @param {boolean} inBasket
     * @param {boolean} selectable
     */
    const getStyle = (inBasket, selectable) => {
      let active = "";
      let unselectable = "";

      if (!selectable) {
        unselectable = "disabled";
      }
      if (inBasket) {
        active = "active";
      }

      return `package__card ${packageClass} ${active} ${unselectable}`;
    };

    /** Functional Components */
    const PackageUpdateAndPrice = props => (
      <div className="package__add__section">{props.children}</div>
    );

    const PackagePrice = props => (
      <div className={`package__price ${familyID === 15 ? "paper__price" : ""}`}>£{Number(props.price).toFixed(2)}</div>
    );

    const MoreInfoButton = ({ toggleDescription, packageClass, site }) =>
      // depending on the class change the button
      props.site.brand.includes("EP") ? (
        <Button
        aria-label="package information"
        className="package__info"
        onClick={toggleDescription}
      >
        <i className="fas fa-info-circle"></i>
      </Button>
      ) : (
        <Button
        variant="outlined"
        size="small"
        aria-label="package information"
        className={`package__info ${props.familyID === 15 ? "paper-package" : ""}`}
        onClick={toggleDescription}
      >
        More info{" "}
        <i className="fa fa-chevron-down"></i>
      </Button>
      );

    const PackageAdded = props =>
      props.inBasket ? (
        <span className="package__add__yes">
          <i className="fa fa-check"></i> {props.children} <span> Added</span>
        </span>
      ) : null;

    const AddPacks = ({ defaultValue, min, max, updatedPackageQuantity }) => (
      <InputPlusAndMinus
        defaultValue={defaultValue}
        min={min}
        max={999}
        updateFunction={updatedPackageQuantity}
      />
    );

    return (
      canOrderMultiple ? (
        <Container fluid>
          <Row className={`paper-packages-container ${selectable ? "" : "disabled"}`}>
            <Col xs={12}  md={3} lg={5}>
              <p className="paper-packages__name">{name}</p>
            </Col>
            <Col xs={12} md={2} lg={2}>
              <MoreInfoButton
                  toggleDescription={toggleDescription}
                  packageBrand={packageBrand}
                  packageClass={packageClass}
                  site={site}
                />
                {props.width < 768?
                  <Col xs={12} className={`${props.familyID === 15 ? "desc__paper-package" : ""}`}>
                  <PackageDescription
                  description={description}
                  visible={descriptionVisible}
                  packageID={packageID}
                  familyID={props.familyID}
                  />
                  </Col>
                : ""
                }
            </Col>
            <Col xs={6} md={2} lg={2} className='package-price'>
              <b>
                <PackagePrice price={price} familyID={familyID} />
              </b>
              <span> per pack </span>
            </Col>
            <Col xs={6} md={3} lg={2}>
              <AddPacks
                defaultValue={packageQuantity}
                min={0}
                max={999}
                updatedPackageQuantity={packQuantity => {
                  updatePackage(packageID, packQuantity);
                }}
              />
            </Col>
            <Col xs={12} md={2} lg={1}>
              <PackageAdded inBasket={inBasket} />
            </Col>
            {props.width >= 768 ? 
              <Col xs={12} className={`${props.familyID === 15 ? "desc__paper-package" : ""}`}>
              <PackageDescription
              description={description}
              visible={descriptionVisible}
              packageID={packageID}
              familyID={props.familyID}
              />
            </Col>
            : ""}
          </Row>
        </Container>
               
              ) : (
        <Card className={getStyle(inBasket, selectable)} elevation={4}>
          <PackageTitle
            packageName={name}
            moreInfoButton={
              <MoreInfoButton
                toggleDescription={toggleDescription}
                packageBrand={packageBrand}
                packageClass={packageClass}
                site={site}
              />
            }
            packageID={packageID}
          />
          {/* Product list, replaces PackageProducts component */}
          <div className="package__products">
            <ul>
              {props.productNameList && productNameList.toString().split(',').map((item, index) => <li key={index}>{item}</li>)}
            </ul>
          </div>
          <PackageDescription
            description={description}
            visible={descriptionVisible}
            packageID={packageID}
          />
          <PackageUpdateAndPrice>
            {/* This uses the state above to work out if the brand is pack based
                or if it is a one time purchase (add to basket) */}
            <Row>

                <Container>
                  {/* Add to basket button, replaces PackageAddToBasket component */}
                  <Button
                    disabled={!selectable}
                    variant="fab"
                    aria-label="add to basket"
                    className={!inBasket ? "package__add__btn" : "package__remove__btn"}
                    onClick={() => updatePackage(packageID)}
                  >
                    <i className={!inBasket ? "fa fa-plus" : "fa fa-minus"} style={{ color: "white" }}></i>
                  </Button>
                  <b>
                    {/* Package price, replaces PackagePrice component */}
                    <PackagePrice price={price} />
                  </b>
                  {props.freeMaths === true ? <span> - Funded by AQA</span> : <span>&nbsp;+ VAT</span>}
                  <PackageAdded inBasket={inBasket} />
                </Container>
            </Row>
          </PackageUpdateAndPrice>
        </Card>
      )
    );
  }

PackageItem.propTypes = {
  size: PropTypes.number,
  selectable: PropTypes.bool,
  inBasket: PropTypes.bool,
  updateBasket: PropTypes.func,
  packageID: PropTypes.number,
  /** Markdown description created in DSDB on the Online > Package management section  */
  description: PropTypes.string,
  name: PropTypes.string,
  /** list of all the products that make up the package */
  productNameList: PropTypes.string,
  packageBrand: PropTypes.string,
  price: PropTypes.number,
  /** if it is 0 then false else if 1 then true */
  canOrderMultiple: PropTypes.number,
  packageQuantity: PropTypes.number,
  /** Site information = TB or EB (etc) */
  site: PropTypes.object
};

export default PackageItem;
